export class CustomLookupOptionModel {
	constructor(public Text?: string, public Value?: number) {
	}
}